import React, {
    Children,
    cloneElement,
    isValidElement,
    PropsWithChildren,
    ReactElement,
} from 'react'

import { useAppSelector } from '../hooks/redux'
import OverlayLoader from '../components/shared/overlay-loader'
import '../components/shared/initFA'
import NavBar from './navigation/Navbar'

/**
 * Top-level layout shell for authenticated pages.
 *
 * Wraps the active route element with the application navbar and a
 * global busy overlay. Children are forwarded with a copy of the
 * current `app` slice (kept for backwards compatibility with legacy
 * children that read it from props).
 */
const AppContainer = ({ children }: PropsWithChildren) => {
    const app = useAppSelector(state => state.app)

    return (
        <>
            <div className="container">
                <NavBar />
            </div>
            <div className="d-flex flex-column flex-fill min-h-65vh">
                {Children.map(children, child => (
                    isValidElement(child)
                        ? cloneElement(child as ReactElement<{ app: unknown }>, { app })
                        : child
                ))}
                {app.busy && <OverlayLoader />}
            </div>
        </>
    )
}

export default AppContainer
